"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.form.title.edit': '编辑知识',
    'knowledge.form.title.add': '添加知识',
    'knowledge.form.back': '返回',
    'knowledge.form.title.label': '标题',
    'knowledge.form.title.placeholder': '输入知识标题',
    'knowledge.form.description.label': '描述',
    'knowledge.form.description.placeholder': '输入知识描述',
    'knowledge.form.description.help': '提供简要描述以帮助识别此知识',
    'knowledge.form.content.label': '内容',
    'knowledge.form.content.placeholder': '输入知识内容',
    'knowledge.form.file.label': '文件',
    'knowledge.form.file.placeholder': '选择文件',
    'knowledge.form.project.label': '项目',
    'knowledge.form.project.placeholder': '选择项目',
    'knowledge.form.tags.label': '标签',
    'knowledge.form.tags.placeholder': '输入用逗号分隔的标签',
    'knowledge.form.tags.help': '按回车键添加标签',
    'knowledge.form.contentType.label': '内容类型',
    'knowledge.form.contentType.help': '选择要添加的内容类型',
    'knowledge.form.contentType.text': '文本',
    'knowledge.form.contentType.file': '文件',
    'knowledge.form.contentType.link': '链接',
    'knowledge.form.contentType.googleDrive': 'Google Drive',
    'knowledge.form.contentType.google-drive': 'Google Drive',
    'knowledge.form.link.label': '链接URL',
    'knowledge.form.link.placeholder': '输入链接的URL',
    'knowledge.form.googleDrive.label': 'Google Drive URL',
    'knowledge.form.googleDrive.placeholder': '输入Google Drive分享URL',
    'knowledge.form.googleDrive.selectFile': '从 Google Drive 选择',
    'knowledge.form.googleDrive.notAuthenticated': 'Google Drive 未连接。请在设置中连接您的账户。',
    'knowledge.form.googleDrive.notConnected': 'Google Drive 未连接',
    'knowledge.form.googleDrive.connect': '在设置中连接',
    'knowledge.form.googleDrive.configureSettings': '在设置中配置',
    'knowledge.form.googleDrive.statusError': '检查 Google Drive 状态失败',
    'knowledge.form.googleDrive.fileSelected': 'Google Drive 文件选择成功',
    'knowledge.form.timed.label': '启用基于时间的可用性',
    'knowledge.form.timed.help': '限制此知识对化身的可用时间',
    'knowledge.form.startTime.label': '开始时间',
    'knowledge.form.startTime.placeholder': '选择开始日期',
    'knowledge.form.endTime.label': '结束时间',
    'knowledge.form.endTime.placeholder': '选择结束日期',
    'knowledge.form.active.label': '活跃',
    'knowledge.form.active.help': '启用此知识以供使用',
    'knowledge.form.rag_status.label': 'RAG状态',
    'knowledge.form.content_type.label': '内容类型',
    'knowledge.form.submit.update': '更新知识',
    'knowledge.form.submit.create': '创建知识',
    'knowledge.form.reset.debug': '将表单重置为初始状态',
    'knowledge.form.reset.complete': '表单部分重置完成',
    'knowledge.form.reset.forNext': '为下一个条目重置表单',
    'knowledge.form.projects.loadError': '加载项目失败：',
    'knowledge.form.load.error': '加载知识失败',
    'knowledge.form.submit.duplicateWarning': '表单提交已在进行中，忽略重复提交',
    'knowledge.form.submit.starting': '开始提交表单，数据：',
    'knowledge.form.submit.updating': '正在更新知识，ID：',
    'knowledge.form.submit.creating': '正在创建新的知识条目',
    'knowledge.form.submit.updateError': '更新知识失败',
    'knowledge.form.submit.createError': '创建知识失败',
    'knowledge.form.submit.updateSuccess': '知识更新成功',
    'knowledge.form.submit.createSuccess': '知识创建成功',
    'knowledge.form.submit.success': '知识创建成功：',
    'knowledge.form.submit.error': '保存知识失败：',
    'knowledge.form.validation.fileRequired': '文件为必填项',
    'knowledge.form.validation.timedDatesRequired': '启用定时功能时需要开始时间和结束时间',
    'knowledge.form.ragOverride.title': '索引设置覆盖',
    'knowledge.form.ragOverride.description': '可选地覆盖此知识条目的默认RAG索引设置。',
};
